import { useContext } from 'react'

// context
import { AppContext } from '../../../../App'

// components
import DataTable, { RowProps } from '../../../data-table/data-table'
import Tag from '../../../tag/tag'

const InjuryReview = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const injuryReviews = appContext?.biomechanicalReport?.injuryReviews || []

	return (
		<>
			<h2>Injury Review (ICD10) - Reported diagnosis</h2>
			<DataTable
				headers={[
					{
						key: 'code',
						label: 'Code',
						nowrap: true,
					},
					{
						key: 'diagnosis',
						label: 'Diagnosis',
						width: '100%',
					},
					{
						key: 'threshold',
						label: 'Threshold',
						nowrap: true,
					},
					{
						key: 'recovery_low',
						label: 'Recovery: Low',
						nowrap: true,
					},
					{
						key: 'recovery_medium',
						label: 'Recovery: Medium',
						nowrap: true,
					},
					{
						key: 'recovery_high',
						label: 'Recovery: High',
						nowrap: true,
					},
				]}
				rows={injuryReviews.map(
					({
						icdCode,
						icdDescription,
						recoveryStats,
						threshold,
					}): RowProps => {
						return {
							code: { content: icdCode },
							diagnosis: { content: icdDescription },
							threshold: {
								content: threshold && (
									<Tag
										theme={threshold.toLowerCase()}
										label={threshold}
									/>
								),
							},
							recovery_low: {
								content: recoveryStats?.min,
							},
							recovery_medium: {
								content: recoveryStats?.avg,
							},
							recovery_high: {
								content: recoveryStats?.max,
							},
						}
					}
				)}
			/>
		</>
	)
}

export default InjuryReview
